var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Ampelsystem:")]),
      _vm._v(" "),
      _c("span", { staticClass: "c-ranking c-ranking--red" }),
      _vm._v(" in mehreren Kolonnen eingeplant\n"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }